import { ITheme } from "../../utils/theme"

export const disclaimerStyle = {
  display: "flex",
  color: (theme: ITheme) => theme.palette.blue[650],
  cursor: "pointer",
  "& p": {
    fontWeight: "bold",
  },
  mb: 2,
  mt: 1
}

export const disclaimerIconStyle = (theme: ITheme) => ({
  color: theme.palette.blue[650],
  mr: '3px',
})

export const disclaimerWrapperStyle = {
  display: "flex",
  flexDirection: "column",
  border: (theme: ITheme) => `solid 2px ${theme.palette.green[500]}`,
  background: (theme: ITheme) => theme.palette.grey["A50"],
}

export const disclaimerContainerStyle = {
  position: "relative",
  width: "100%",
  margin: "auto"
}

export const disclaimerContentStyle = {
  position: "absolute",
  zIndex: "999",
  top: "40px",
  width: "100%"
}

export const bodyStyle = {
  color: (theme: ITheme) => theme.palette.common.black,
  padding: 1
}

export const PdfLinkStyle = {
  mb: 2
}

export const selectStyle = {
  mb: 2,
  width: '100%',
  "&.MuiOutlinedInput-root": {
    "& .MuiSelect-select": {
      padding: "10px 15px",
    }
  }
}

export const SelectMenuStyle = {
  maxHeight: { xs: 300, sm: 400, md: 500 }
}

export const PlaceholderStyle = {
  color: (theme: ITheme) => theme.palette.grey[400]
}

export const descriptionStyle = (theme: ITheme) => ({
  mt: 3,
  mb: 3,
  borderTop: `1px solid ${theme.palette.grey[700]}`,
  pt: 3,
})

export const asteriskStyle = {
  color: (theme: ITheme) => theme.palette.red.A700
}